import React, { useEffect } from 'react';
import SEO from "../components/seo"

const Login = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.location.replace('https://my.1centre.com');
    }
  })

  return (
    <SEO
      keywords={['Login']}
      title="Trade platform login"
    />
  );
}
  
export default Login;
   